import TenantPage from 'components/common/TenantPage';
import { getModelLabel } from '../config/modelsMap';
import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import ObjectVersionsPanel from '../components/ObjectVersionsPanel';

export const DeletedObjectVersionsPage = () => {
  const { t } = useTranslation();
  const { model_name, object_id } = useParams();
  const [hasDeleteVersion, setHasDeleteVersion] = useState<boolean>(false);

  const titleKey = hasDeleteVersion
    ? 'pages.versions.deleted.view.title'
    : 'pages.versions.object.view.title';

  return (
    <TenantPage title={t(titleKey)} subtitle={`${getModelLabel(model_name)} id: ${object_id}`}>
      <div className="mt-6">
        <ObjectVersionsPanel
          modelName={model_name}
          objectId={object_id}
          onMetaChange={({ hasDeleteVersion }) => setHasDeleteVersion(hasDeleteVersion)}
        />
      </div>
    </TenantPage>
  );
};

export default DeletedObjectVersionsPage;
